import { call, put } from 'redux-saga/effects';
import { API, RequestOptions } from '../../../../api';
import { entropyPasswordData, EntropyPasswordFetch } from '../actions';

const config: RequestOptions = {
    apiVersion: 'barong',
};

export function* entropyPassword(action: EntropyPasswordFetch) {
    try {
        const data = yield call(API.post(config), '/identity/password/validate', action.payload);
        yield put(entropyPasswordData(data));
    } catch (error) {
        // yield put(entropyPasswordError(error));
        // yield put(sendError({
        //     error,
        //     processingType: 'alert',
        //     extraOptions: {
        //         actionError: entropyPasswordError,
        //     },
        // }));
    }
}
